import React, { useEffect, useState, useContext } from 'react'
import _ from "lodash"
import { useTranslation } from 'react-i18next'

import { UserContext } from "context/auth";

import useFetchStatus from "customHooks/useFetchStatus"
import CustomTable from "../components/ReactTable"
import TitleWithBtn from "../components/Titles/TitleWithBtn"
import PreviewModal from "main_views/Tasks/previewModal"
import { getTicketStep2, handleTicket, addDate } from "main_views/Tasks/handler"
import ReRequestModal from "main_views/form/request/reRequestModal"

function History() {

    let { t } = useTranslation()
    let { user: currentUser } = useContext(UserContext)

    let redirectTicketsQuery = [
        { field: "approvedBy", value: null, isNotEqual: true },
        { field: "redirects", value: null, isNotEqual: true },
    ]

    let [selectedTicket, setSelectedTicket] = useState()
    let [tickets, ticketError, isTicketLoading] = useFetchStatus(`tickets`, {}, [selectedTicket])
    let [staffs, staffsError, isStaffsLoading] = useFetchStatus(`staff`, {}, [], null)

    let [filteredData, setFilteredData] = useState()

    // preview Request Modal
    let [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false)
    let [previewingTicket, setPreviewTicket] = useState()
    let [historyList, setHistoryList] = useState([])
    let [isHandling, setHandling] = useState(false)

    // re-request Modal
    let [selectedFormToReRequest, setSelectedFormToReRequest] = useState()

    useEffect(() => {
        let ticketsList = _.values(tickets)
        ticketsList = _.filter(tickets, ticket => !_.isEmpty(ticket.approvedBy) || !_.isEmpty(ticket.redirects))

        setHandling(true)

        Promise.resolve(handleHistory(ticketsList, staffs, currentUser)).then(data => {
            setHandling(false)
            setHistoryList(data)
        })

    }, [tickets, staffs])


    const previewTicket = (index) => {
        setPreviewTicket(filteredData[index])
        setIsPreviewModalOpen(true)
    }

    const Header = [
        {
            Header: "#",
            accessor: "number",
            type: "string",
            sortable: true,
        },
        {
            Header: t('requester_name'),
            accessor: "requesterName",
            type: "string",
            sortable: true,
        },
        {
            Header: t('form_name'),
            accessor: "form.name",
            type: "string",
            sortable: true,
        },
        {
            Header: t('due_date'),
            accessor: "dueDate",
            type: "firestoreTime",
            sortable: true,
        },
        {
            Header: t('priority'),
            accessor: "priority",
            type: "priorityTxt",
            sortable: true,
        },
        {
            Header: t('state'),
            accessor: "step",
            type: "string",
            sortable: true,
        },
        {
            Header: t('date_and_time'),
            accessor: "date",
            type: "dateAndTime",
            sortable: false,
        },
        {
            Header: " ",
            buttonTitle: t('preivew'),
            type: "button",
            color: "info",
            isOutline: true,
            sortable: false,
            onClick: previewTicket,
        },
        {
            Header: " ",
            buttonTitle: t('re_request'),
            type: "reRequest_btn",
            color: "warning",
            isOutline: true,
            sortable: false,
            onClick: (requestInfo) => setSelectedFormToReRequest(requestInfo),
        },
    ]

    return (
        <div className="content">

            <TitleWithBtn
                title={t('my_history')}
            />

            {/*Display Tickets list */}
            <CustomTable
                title={t('my_history')}
                header={Header}
                loading={isTicketLoading || isHandling}
                body={historyList}
                hasSearchBar={true}
                searchBarTitle={t('search')}
                setFilterResult={setFilteredData}
                selectDateRangeBeforeExport={true}
                exportData={historyList} // fixed data to export
            />

            {/* Preview ticket modal */}
            {(!isTicketLoading && !isHandling && previewingTicket )&& (
                <PreviewModal
                    isOpen={isPreviewModalOpen}
                    toggle={() => setIsPreviewModalOpen(false)}
                    ticket={previewingTicket}
                    staffs={staffs}
                />
            )}

            {selectedFormToReRequest && (
                <ReRequestModal
                    toggle={() => setSelectedFormToReRequest(null)}
                    reRequestForm={selectedFormToReRequest}
                />
            )}

        </div>

    )
}

export default History

async function handleHistory(tickets, staffs, currentUser) {
    let data = getStaffHistory(tickets, currentUser.id)
    let handledData = await Promise.all(_.map(data, (ticket) => ticket = addDate(ticket) ))
    let dataWithStep = await getTicketStep2(handledData, staffs)

    return dataWithStep

}

function getStaffHistory(tickets, currentUserId) {

    let history = []

    _.forEach(tickets, ticket => {

        let approvedIds = _.map(ticket.approvedBy, approved => approved.id)

        if (approvedIds.includes(currentUserId)) history.push(ticket)

        if (!_.isEmpty(ticket.redirects)) {

            let redirectedIds = _.map(ticket.redirects, redirect => redirect.directedBy)

            if (redirectedIds.includes(currentUserId)) history.push(ticket)

        }

    })

    return history
}
